import { resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_AICopilot = _resolveComponent("AICopilot");
  const _component_Footer = _resolveComponent("Footer");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-container", {
      'copilot-open': $setup.copilotOpen
    }])
  }, [_createVNode(_component_Header), _createElementVNode("div", {
    class: _normalizeClass(["main-content-wrapper", {
      'with-ai-copilot': $setup.copilotOpen
    }])
  }, [_createVNode(_Transition, {
    name: "fade",
    mode: "out-in"
  }, {
    default: _withCtx(() => [_createVNode(_component_router_view)]),
    _: 1
  })], 2), _createVNode(_component_AICopilot), _createVNode(_component_Footer)], 2);
}